export const Size = {
  Large: 22,
  Pronounced: 18,
  Default: 16,
  Small: 14,
  Micro: 12,
};
